const helpers = require('./helpers')

/**
 * This file contains GTM function calls. If you try to call this on SSR it will fail as it's not loaded until
 * browser inits this library
 */

const ON_SSR = 'ON_SSR'

/**
 * Promisified function to see if GTM is loaded
 */
function ready() {
  return new Promise((resolve, reject) => {
    try {
      // If we are on the server, make the call manually
      if (!helpers.isBrowser()) {
        return reject(ON_SSR)
      }

      // Check if GTM is available or create empty array
      window.dataLayer = window.dataLayer || []

      return resolve(window.dataLayer)
    } catch (e) {
      reject(e)
    }
  })
}

/**
 * 🚀 ---------------------------------------------------
 * DEPRECATED: now we load it via node-foundation
 * 🚀 ---------------------------------------------------
 * It adds the GTM scrips to the page (one to the head and one to the
 * body as requested by Google).
 * @param {string} gtmId GTM container id
 */
function setUpGoogleTagManagerScripts (gtmId) {
  const externalSrc = '//www.googletagmanager.com/gtm.js?id='
  if (helpers.hasScriptAlreadyLoaded(externalSrc)) {
    return
  }
  const scriptContent = `(function (w, d, s, l, i) {
    w[l] = w[l] || []
    w[l].push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    })
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l != 'dataLayer' ? '&l=' + l : ''
    j.async = true
    j.src = '${externalSrc}' + i + dl
    f.parentNode.insertBefore(j, f)
  })(window, document, 'script', 'dataLayer', '${gtmId}')`
  const script = document.createElement('script')
  script.innerHTML = scriptContent
  document.head.insertBefore(script, document.head.childNodes[0])
}

/**
 * Push the event to dataLayer to fire it in GTM
 * @param {string} eventName Event name defined in GTM
 * @param {object} properties All the properties you want to append to the event
 */
function trackEvent(eventName, properties) {
  return ready()
    .then(gtm =>
      gtm.push({
        event: eventName,
        ...properties,
      })
    )
    .catch(e => {
      if (e === ON_SSR) {
        return console.warn(
          'You tried to send an event to GTM when in Server Side Rendering'
        )
      }
      console.error(e)
    })
}

module.exports = {
  trackEvent,
  setUpGoogleTagManagerScripts,
}
